<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>Add Bowler</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form>
                <v-layout row wrap>
                    <v-flex >
                        <v-text-field placeholder="First Name" v-model="firstName" />
                    </v-flex>
                    <v-flex >
                        <v-text-field placeholder="Last Name" v-model="lastName" />
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-layout column>
                <v-btn color="primary" @click="submit" >Submit</v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    export default {
        name: "add-bowler",
        data () {
            return {
                firstName: null,                
                lastName: null,
                url: "https://nostyleguy.com/api/bowlers"
            }
        },
        methods: {
            submit: async function(){
                let payload = {
                    first_name: this.firstName,
                    last_name: this.lastName
                };
                axios({
                    method: "POST",
                    url: this.url,
                    data: payload,
                    headers: {
                        "content-type": "application/json"
                    }
                }).
                then(
                    result => {
                        console.log(JSON.stringify(result.data));
                        this.$store.dispatch('getBowlers');
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
        }
    }
</script>

<style scoped>
.v-btn {
    min-width: 150px;
}
</style>